var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7794 2.91C15.7794 1.58 16.8594 0.5 18.1894 0.5C19.5194 0.5 20.5994 1.58 20.5994 2.91C20.5994 4.24 19.5194 5.32 18.1894 5.32C16.8594 5.32 15.7794 4.24 15.7794 2.91ZM11.9293 13.2593L14.8193 9.5303L14.7793 9.5503C14.9393 9.3303 14.9693 9.0503 14.8593 8.8003C14.7503 8.5503 14.5093 8.3803 14.2503 8.3603C13.9793 8.3303 13.7103 8.4503 13.5493 8.6703L11.1303 11.8003L8.3593 9.6203C8.1893 9.4903 7.9893 9.4393 7.7893 9.4603C7.5903 9.4903 7.4103 9.5993 7.2893 9.7593L4.3303 13.6103L4.2693 13.7003C4.0993 14.0193 4.1793 14.4293 4.4793 14.6503C4.6193 14.7403 4.7693 14.8003 4.9393 14.8003C5.1703 14.8103 5.3893 14.6893 5.5293 14.5003L8.0393 11.2693L10.8893 13.4103L10.9793 13.4693C11.2993 13.6393 11.6993 13.5603 11.9293 13.2593ZM14.0493 2.2803C14.0093 2.5303 13.9893 2.7803 13.9893 3.0303C13.9893 5.2803 15.8093 7.0993 18.0493 7.0993C18.2993 7.0993 18.5393 7.0703 18.7893 7.0303V15.0993C18.7893 18.4903 16.7893 20.5003 13.3893 20.5003H6.0003C2.5993 20.5003 0.599304 18.4903 0.599304 15.0993V7.7003C0.599304 4.3003 2.5993 2.2803 6.0003 2.2803H14.0493Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsActive);
export default __webpack_public_path__ + "static/media/news_active.651a459c06e8a118b652286aea9e258b.svg";
export { ForwardRef as ReactComponent };